import PropTypes from "prop-types";

import FormButtonsForCloseAndSubmit from "../Common/Forms/FormButtonsForCloseAndSubmit";
import TextInput from "../Common/Forms/TextInput";

const InnsynPersonopplysningerFilterForm = ({
  showSokSpinner,
  innsynPersonopplysningerFilterForm,
  handleOnChange,
  handleOnSubmit,
  handleOnChangeToInitState,
}) => {
  return (
    <form
      id="personopplysninger-filter"
      className="SearchFormDiv"
      onSubmit={handleOnSubmit}
    >
      <div className="SearchFilterOverskrift">Søk etter personopplysninger</div>
      <div className="filter-flexbox-container">
        <TextInput
          label="E-post"
          name="epost"
          type="email"
          onChange={handleOnChange}
          value={innsynPersonopplysningerFilterForm.epost}
          validationError={
            innsynPersonopplysningerFilterForm.epostValidationError
          }
        />
      </div>
      <div style={{ marginTop: 20 }}>
        <FormButtonsForCloseAndSubmit
          showSubmitSpinner={showSokSpinner}
          submitText="Søk"
          onClose={handleOnChangeToInitState}
        />
      </div>
    </form>
  );
};

InnsynPersonopplysningerFilterForm.propTypes = {
  showSokSpinner: PropTypes.bool.isRequired,
  innsynPersonopplysningerFilterForm: PropTypes.shape({
    epost: PropTypes.string,
    epostValidationError: PropTypes.string,
  }).isRequired,
  handleOnChange: PropTypes.func.isRequired,
  handleOnSubmit: PropTypes.func.isRequired,
  handleOnChangeToInitState: PropTypes.func.isRequired,
};

export default InnsynPersonopplysningerFilterForm;
